module.exports = __webpack_public_path__ + "assets/img/iso.ae7c22f9.svg";